/* eslint-disable no-unused-vars */

export enum DeliveryNoteStatusEnum {
  PENDING = 'pending',
  READY_PRINT = 'ready_print',
  PRINTED = 'printed',
  PENDING_REPRINT = 'pending_reprint',
  READY_REPRINT = 'ready_reprint',
  REPRINTED = 'reprinted',
  CANCELLED = 'cancelled',
}

export enum DeliveryNoteSearchCriteriaEnum {
  ALL = 'all',
  PENDING = 'pending',
  READY_PRINT = 'ready_print',
  PRINTED = 'printed',
  PENDING_REPRINT = 'pending_reprint',
  READY_REPRINT = 'ready_reprint',
  REPRINTED = 'reprinted',
  CANCELLED = 'cancelled',
}
